<template>
    
</template>

<script>
import Cookies from 'js-cookie';
import { EventBus } from '../../lib/event-bus.js';

export default {
	data() {
		return {
			datalayer: {
				url: window.location.href,
				session_id: null,
				event: 'pageview',
			},
		};
	},
	mounted(){
        
		EventBus.$on('track-event', (data) => {
			// console.log(data);
		});
            
		if(typeof Cookies.get('huddle_tracker_uuid') !== 'undefined'){
			this.datalayer.session_id = Cookies.get('huddle_tracker_uuid');     
			this.refreshSession();       
		} else {
			this.generateSession();
		}

		this.track();

	},
	methods: {
		generateSession: function() {
			let inThirtyMinutes     = new Date(new Date().getTime() + 30 * 60 * 1000);
			let id                  = this.uuidv4();
			let cookie              = Cookies.set('huddle_tracker_uuid', id, {
				expires: inThirtyMinutes
			});
            
			this.datalayer.session_id = id;
		},
		refreshSession: function() {
			let inThirtyMinutes     = new Date(new Date().getTime() + 30 * 60 * 1000);
			let id                  = this.datalayer.session_id;

			Cookies.remove('huddle_tracker_uuid');

			let cookie              = Cookies.set('huddle_tracker_uuid', id, {
				expires: inThirtyMinutes
			});
		},
		track: function() {

			axios.post('/api/v3/track', this.datalayer).then(function(){
            
			}).catch(function(error){  });
            
		},
		uuidv4: function() {
			return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
				(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
			);
		}
	}
};
</script>